import { render } from "./ToolingQuote.vue?vue&type=template&id=2124e80e"
import script from "./ToolingQuote.vue?vue&type=script&lang=js"
export * from "./ToolingQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__